module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 3rem 0",
      "height": "100%"
    }
  }, [_c('van-notice-bar', {
    attrs: {
      "scrollable": true
    },
    on: {
      "click": _vm.edit
    }
  }, [_vm._v("\n        本地队伍可以选择不住宿，无需填写接送站信息，如有问题点这里\n    ")]), _vm._v(" "), (_vm.pageData.confirm_5 == 2) ? _c('div', [_c('van-divider', [_vm._v("单位信息")]), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "赛季",
      "value": _vm.pageData.sjname
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "赛区",
      "value": _vm.pageData.sqname
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "单位",
      "value": _vm.pageData.danwei
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "队伍名称",
      "value": _vm.pageData.mingcheng
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "sub-title",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("送站信息")]), _vm._v(" "), _c('van-cell-group', [_c('van-field', {
    attrs: {
      "required": "",
      "clearable": "",
      "label": "送站地点",
      "readonly": "",
      "placeholder": "请选择送站地点"
    },
    on: {
      "click": function($event) {
        _vm.showStation = true;
        _vm.stationField = 'go'
      }
    },
    model: {
      value: (_vm.formData.go_station_name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "go_station_name", $$v)
      },
      expression: "formData.go_station_name"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "required": "",
      "clearable": "",
      "label": "车次",
      "placeholder": "请输入车次或者航班号"
    },
    model: {
      value: (_vm.formData.go_transcode),
      callback: function($$v) {
        _vm.$set(_vm.formData, "go_transcode", $$v)
      },
      expression: "formData.go_transcode"
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "人数"
    }
  }, [_c('van-stepper', {
    attrs: {
      "required": "",
      "placeholder": "请输入人数",
      "min": 1,
      "max": _vm.pageData.total_member_count
    },
    on: {
      "change": _vm.memberChange
    },
    model: {
      value: (_vm.formData.go_member_count),
      callback: function($$v) {
        _vm.$set(_vm.formData, "go_member_count", $$v)
      },
      expression: "formData.go_member_count"
    }
  })], 1), _vm._v(" "), _c('van-field', {
    attrs: {
      "required": "",
      "clearable": "",
      "label": "送站时间",
      "readonly": "",
      "placeholder": "请选择送站时间"
    },
    on: {
      "click": function($event) {
        _vm.showTime = true;
        _vm.timeField = 'go'
      }
    },
    model: {
      value: (_vm.formData.go_date_time),
      callback: function($$v) {
        _vm.$set(_vm.formData, "go_date_time", $$v)
      },
      expression: "formData.go_date_time"
    }
  })], 1), _vm._v(" "), _c('van-notice-bar', {
    attrs: {
      "scrollable": false
    }
  }, [_vm._v("\n            送站时间是从酒店出发的时间，建议按车次时间提前2-3小时\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "fixed",
      "bottom": "0px",
      "z-index": "1000",
      "width": "100%"
    }
  }, [(_vm.showTime) ? _c('van-datetime-picker', {
    attrs: {
      "type": "datetime",
      "min-date": new Date(),
      "formatter": _vm.formatter
    },
    on: {
      "confirm": _vm.timeConfirm,
      "cancel": function($event) {
        _vm.showTime = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showStation) ? _c('van-picker', {
    attrs: {
      "show-toolbar": "",
      "title": "选择站点",
      "columns": _vm.pageData.station_list,
      "value-key": "name"
    },
    on: {
      "cancel": function($event) {
        _vm.showStation = false
      },
      "confirm": _vm.stationConfirm
    }
  }) : _vm._e()], 1)], 1) : _c('div', [_c('van-divider', [_vm._v("单位信息")]), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "赛季",
      "value": _vm.pageData.sjname
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "赛区",
      "value": _vm.pageData.sqname
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "单位",
      "value": _vm.pageData.danwei
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "队伍名称",
      "value": _vm.pageData.mingcheng
    }
  })], 1), _vm._v(" "), _c('van-divider', [_vm._v("送站信息")]), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "送站地点",
      "value": _vm.pageData.bus_take.go_station_name
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "车次",
      "value": _vm.pageData.bus_take.go_transcode
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "人数",
      "value": _vm.pageData.bus_take.go_member_count
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "送站时间",
      "value": _vm._f("date")(_vm.pageData.bus_take.go_date_time)
    }
  })], 1), _vm._v(" "), _c('van-notice-bar', {
    attrs: {
      "scrollable": false
    }
  }, [_vm._v("\n            送站时间是从酒店出发的时间，建议按车次时间提前2-3小时\n        ")]), _vm._v(" "), _c('van-divider', [_vm._v("车辆信息")]), _vm._v(" "), (_vm.pageData.bus_list.length) ? _c('van-cell-group', _vm._l((_vm.pageData.bus_list), function(bus, index) {
    return (bus.type == 2) ? _c('van-cell', {
      attrs: {
        "title": bus.name
      }
    }, [(bus.type == 1) ? _c('div', [_vm._v(" 接站 ")]) : _c('div', [_vm._v(" 送站 ")])]) : _vm._e()
  }), 1) : _c('van-divider', [_vm._v("等待更新")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "20px"
    }
  }, [(_vm.pageData.confirm_5 == 2) ? _c('van-button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.add.apply(null, arguments)
      }
    }
  }, [_vm._v("提交信息")]) : (_vm.pageData.confirm_5 == 3) ? _c('van-button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.save.apply(null, arguments)
      }
    }
  }, [_vm._v("信息无误 我已确认")]) : (_vm.pageData.confirm_5 == 1) ? _c('van-button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "plain": ""
    }
  }, [_vm._v("信息已确认")]) : _vm._e(), _vm._v(" "), (_vm.pageData.confirm_5 == 2) ? _c('van-button', {
    staticStyle: {
      "margin": "10px 0"
    },
    attrs: {
      "type": "primary",
      "size": "large",
      "plain": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.cancel.apply(null, arguments)
      }
    }
  }, [_vm._v("我不需要接送站")]) : _vm._e(), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "margin": "10px 0"
    },
    attrs: {
      "size": "large",
      "plain": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.edit.apply(null, arguments)
      }
    }
  }, [_vm._v("信息需要修改")]), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "margin": "10px 0"
    },
    attrs: {
      "size": "large",
      "plain": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goIndex.apply(null, arguments)
      }
    }
  }, [_vm._v("返回首页")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74a4d041","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/sai/saiConfirmDetail5.vue
// module id = 1538
// module chunks = 0